module.exports = __webpack_public_path__ + "static/media/Chapter14.648d0a1a.pdf";